import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Articles from "../views/Articles.vue";
import Article from "../views/Article.vue";
import Contact from "../views/Contact.vue";
import Project from "../views/Project.vue";
import Download from "../views/Download.vue";
import Cotacoes from "../views/Cotacoes.vue";
import Videos from "../views/Videos.vue";
import Fotos from "../views/Events.vue";
import Foto from "../views/Event.vue";
import Video from "../views/Video.vue";
import Diretoria from "../views/Direction.vue";
import Error404 from "../views/Error404.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Abrajas",
    component: Home,
  },
  {
    path: "/conheca",
    name: "Conheça - Abrajas",
    component: About,
  },
  {
    path: "/noticias",
    name: "Notícias - Abrajas",
    component: Articles,
  },
  {
    path: "/noticias/:article",
    name: "Notícia - Abrajas",
    component: Article,
  },
  {
    path: "/projeto",
    name: "Projeto MT 140/422 - Abrajas",
    component: Project,
  },
  {
    path: "/transparencia",
    name: "Transparência - Abrajas",
    component: Download,
  },
  {
    path: "/cotacoes",
    name: "Cotações de preço - Abrajas",
    component: Cotacoes,
  },
  {
    path: "/videos",
    name: "Vídeos - Abrajas",
    component: Videos,
  },
  {
    path: "/videos/:video",
    name: "Vídeo - Abrajas",
    component: Video,
  },
  {
    path: "/fotos",
    name: "Fotos da Obra - Abrajas",
    component: Fotos,
  },
  {
    path: "/fotos/:photo",
    name: "Fotos - Abrajas",
    component: Foto,
  },
  {
    path: "/contato",
    name: "Contato - Abrajas",
    component: Contact,
  },
  {
    path: "*",
    name: "Error404",
    component: Error404,
  },
  {
    path: "/diretoria",
    name: "Diretoria - Abrajas",
    component: Diretoria,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  document.title = to.name;
  window.scrollTo(0, 0);
});

export default router;
